import React from 'react';
import { Logo } from '../ui/Logo';
interface BrandLogoProps {
  /** Logotipo propio de la empresa. Si no existe, se usa el logo del Sistema AVA. */
  src?: string;
  size?: number;
  showWordmark?: boolean;
  alt?: string;
  className?: string;
}

/**
 * Punto único donde se resuelve el logotipo mostrado en toda la plataforma:
 * sidebar, dashboard, landings, formularios, footer y página de gracias.
 */
export function BrandLogo({
  src,
  size = 28,
  showWordmark = true,
  alt = 'Logotipo',
  className = ''
}: BrandLogoProps) {
  if (src) {
    return <img src={src} alt={alt} style={{
      height: Math.round(size * 1.5)
    }} className={`w-auto max-w-[200px] object-contain ${className}`} data-id="element-574" data-mp="3pjlnwij3lyn7" />;
  }
  return <Logo size={size} showWordmark={showWordmark} className={className} data-id="element-575" data-mp="3fpda70yq8a93" />;
}